import React, { Fragment, useState } from 'react';
import { useParams, useMatch, Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Spinner from '../layout/Spinner';
import logo from '../../img/ascorel.png';
import { updateForgottenPwd } from '../../actions/user';
import Card from 'react-bootstrap/Card';
import { GrCodepen } from 'react-icons/gr';
import { GoVerified } from 'react-icons/go';
import Form from 'react-bootstrap/Form';
import { setAlert } from '../../actions/alert';
import { useTranslation, Trans } from 'react-i18next';

const ResetPassword = ({ setAlert, updateForgottenPwd, user: { user } }) => {
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const { token } = useParams();
  const activation = useMatch(`/activation/${id}/${token}`);
  const { t, i18n } = useTranslation();

  const [formData, setFormData] = useState({
    password: '',
    password2: '',
    acceptCGU: false
  });

  const { password, password2, acceptCGU } = formData;

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    if (password !== password2 || password.length < 6) {
      setAlert(i18n.t('passwordWarning'), 'danger');
    } else {
      if (!acceptCGU && activation) {
        setAlert(i18n.t('acceptCGUWarning'), 'danger');
      } else {
        setLoading(true);
        if (id && token) updateForgottenPwd(id, token, formData);
      }
    }
  };

  return (
    <section className="container">
      <Fragment>
        {loading && !user ? (
          <Spinner />
        ) : (
          <Fragment>
            {/* <h4 className="p-3 mb-2 bg-ascorel text-white text-center">
              Reinitialisation du mot de passe
            </h4> */}
            <div className="parent-flex">
              <div>
                <img src={logo} alt="logo" height="100" />
              </div>
            </div>
            <div>
              {!user ? (
                <Fragment>
                  <Card className="card-style-activate">
                    <GrCodepen
                      size={96}
                      className="icon-center my-3"
                      color="white"
                    />
                    <Card.Body className="col-6">
                      {activation ? (
                        <Card.Title className="card-header-color-title-activate text-center">
                          {t('reset_pw_title1')}
                        </Card.Title>
                      ) : (
                        <Card.Title className="card-header-color-title-activate text-center">
                          {t('reset_pw_title2')}
                        </Card.Title>
                      )}
                      <Card.Text
                        className="card-header-color text-center"
                        style={{ marginTop: '3rem' }}
                      >
                        <form className="form" onSubmit={(e) => onSubmit(e)}>
                          <div className="form-group">
                            {' '}
                            <Form.Control
                              type="password"
                              name="password"
                              placeholder={t('pw_ph')}
                              value={password}
                              onChange={(e) => onChange(e)}
                            />
                            <small className="form-text-white">
                              {t('reset_pw_pw1')}
                            </small>
                          </div>

                          <div className="form-group">
                            <Form.Control
                              type="password"
                              name="password2"
                              placeholder={t('pass2_ph')}
                              value={password2}
                              onChange={(e) => onChange(e)}
                            />
                            <small className="form-text-white">
                              {t('reset_pw_pw2')}
                            </small>
                          </div>
                          {activation ? (
                            <div className="form-group">
                              <div
                                className="checkbox"
                                style={{ marginBottom: '1rem' }}
                              >
                                <Form.Check
                                  className="col-auto"
                                  defaultChecked={false}
                                  name="acceptCGU"
                                  onClick={(e) =>
                                    onChange({
                                      target: {
                                        name: 'acceptCGU',
                                        value: e.target.checked
                                      }
                                    })
                                  }
                                />

                                <label
                                  className="col-auto form-text-white"
                                  style={{
                                    marginLeft: '0.5rem',
                                    marginTop: '0.2rem'
                                  }}
                                >
                                  <Trans i18nKey="acceptCGU">
                                    x
                                    <Link to="/cgu" className="link_white">
                                      y
                                    </Link>
                                    .
                                  </Trans>
                                </label>
                              </div>
                            </div>
                          ) : (
                            <Fragment></Fragment>
                          )}

                          <input
                            type="submit"
                            className="btn btn-light"
                            value={t('save')}
                          />
                        </form>
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Fragment>
              ) : (
                <Fragment>
                  <Card className="card-style-activate">
                    <GoVerified
                      size={96}
                      className="icon-center my-3"
                      color="green"
                    />
                    <Card.Body>
                      {activation ? (
                        <Card.Title className="card-header-color-title-activate text-center">
                          {t('success_account')}
                        </Card.Title>
                      ) : (
                        <Card.Title className="card-header-color-title-activate text-center">
                          {t('success_pw')}
                        </Card.Title>
                      )}
                    </Card.Body>
                  </Card>
                </Fragment>
              )}
            </div>
          </Fragment>
        )}
      </Fragment>
    </section>
  );
};

ResetPassword.propTypes = {
  setAlert: PropTypes.func.isRequired,
  updateForgottenPwd: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  user: state.user
});

export default connect(mapStateToProps, {
  updateForgottenPwd,
  setAlert
})(ResetPassword);
